import { Injectable, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

export const SKIP_BACK_ORIGIN = 'skipBackOrigin';

@Injectable({ providedIn: 'root' })
export class BackOriginService {
  private readonly router = inject(Router);

  readonly originUrl: Signal<string | null> = toSignal(
    this.router.events.pipe(
      filter(
        (event): event is NavigationEnd =>
          event instanceof NavigationEnd && !this.shouldSkipOrigin(),
      ),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: null },
  );

  private shouldSkipOrigin(): boolean {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.data[SKIP_BACK_ORIGIN] === true;
  }
}
